if (!customElements.get('m-custom-feature-tabs')) {
  class MCustomFeatureTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.m-cf-tabs__nav-btn');
      this.panels = this.querySelectorAll('.m-cf-tabs__panel');
      this.activeClass = 'is-active';

      this._bindEvents();
      this._bindDesignMode();
    }

    _bindEvents() {
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const index = Number(btn.dataset.index) || 0;
          this.setActiveTab(index);
        });
      });
    }

    _bindDesignMode() {
      if (!window.Shopify || !window.Shopify.designMode) return;

      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const target = event.target;
        const btn =
          target.closest('.m-cf-tabs__nav-btn') ||
          (target.dataset && target.dataset.index !== undefined ? target : null);
        if (btn && btn.dataset && btn.dataset.index !== undefined) {
          this.setActiveTab(Number(btn.dataset.index) || 0);
          return;
        }

        const blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        const panelByBlock = this.querySelector(`.m-cf-tabs__panel [data-shopify-editor-block*="${blockId}"]`);
        if (panelByBlock) {
          const panel = panelByBlock.closest('.m-cf-tabs__panel');
          if (panel && panel.dataset.index !== undefined) {
            this.setActiveTab(Number(panel.dataset.index) || 0);
          }
        }
      });
    }

    setActiveTab(index) {
      this.buttons.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle(this.activeClass, active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle(this.activeClass, active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('m-custom-feature-tabs', MCustomFeatureTabs);
}
